import React from 'react';
import movieWebM from '../assets/nile-sunset.webm';
import movieMP4 from '../assets/nile-sunset.mp4';
import FeaturedProducts from './Products/Featured';
import HomeButtons from './HomeButtons';
import PromiseBanner from './PromiseBanner';
import FaqPage from './FaqPage';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.tryPlay = this.tryPlay.bind(this);
  }

  componentDidMount() {
    this.tryPlay();
  }

  tryPlay() {
    const video = this.videoRef.current;
    if (!video) return;

    // iOS Safari often ignores React's muted/playsInline for autoplay policy.
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const play = video.play();
    if (play && typeof play.catch === 'function') {
      play.catch(() => {
        // Autoplay can still be blocked (e.g. Low Power Mode); ignore.
      });
    }
  }

  render() {
    return (
      <div className="Home">
        <div className="Vid-wrap">
          <video
            ref={this.videoRef}
            className="Video"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            onCanPlay={this.tryPlay}
            onLoadedData={this.tryPlay}
          >
            <source src={movieMP4} type="video/mp4" />
            <source src={movieWebM} type="video/webm" />
          </video>
          <HomeButtons />
        </div>
        <FeaturedProducts />
        <PromiseBanner />
        <FaqPage embedded />
      </div>
    );
  }
}

export default Home;
